import axios from "axios";
import React, { useEffect, useState } from "react";
import { Error } from "../../../../../commons/Messages/Messages";
import TasksComponent from "../../../../../commons/Tasks/Tasks";

// The employee's tasks (those they are on the team of), on the shared task board.
const EmployeeTasks = ({ employeeObject }) => {
  const [tasks, setTasks] = useState([]);

  const getTasks = async () => {
    if (!employeeObject?._id) return;
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/tasks/filters`,
        { employee: employeeObject._id },
        { headers: { Authorization: "Bearer " + localStorage.getItem("token") } }
      );
      setTasks(res.data || []);
    } catch (err) {
      console.error("Error fetching tasks:", err);
      Error(err.response?.data?.errorMessage || err.message);
    }
  };

  // The profile loads the employee after this tab mounts.
  useEffect(() => {
    getTasks();
  }, [employeeObject?._id]);

  return <TasksComponent employeeView tasks={tasks} updateData={getTasks} />;
};

export default EmployeeTasks;
